import { Icon, IconProps } from './Icon';

export const CalendarActiveIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 28 28"
  >
    <defs>
      <linearGradient
        id="paint0_linear_5301_94063"
        x1="20.9556"
        y1="5.90048"
        x2="0.0867683"
        y2="23.0325"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15C3FF" />
        <stop
          offset="1"
          stopColor="#8DF4DB"
        />
      </linearGradient>
    </defs>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.83338 3.09766C7.58817 3.09766 8.20004 3.70953 8.20004 4.46432V6.7421H10.0223V4.46432C10.0223 3.70954 10.6341 3.09766 11.3889 3.09766C12.1437 3.09766 12.7556 3.70953 12.7556 4.46432V6.7421H14.5778V4.46432C14.5778 3.70954 15.1897 3.09766 15.9445 3.09766C16.6993 3.09766 17.3112 3.70953 17.3112 4.46432V6.7421H19.1334V4.46432C19.1334 3.70954 19.7453 3.09766 20.5 3.09766C21.2548 3.09766 21.8667 3.70953 21.8667 4.46432V6.7421H24.6C25.6064 6.7421 26.4223 7.55794 26.4223 8.56432V23.3243C26.4223 24.3307 25.6064 25.1465 24.6 25.1465H3.64449C2.6381 25.1465 1.82227 24.3307 1.82227 23.3243V8.56432C1.82227 7.55794 2.6381 6.7421 3.64449 6.7421H5.46671L5.46671 4.46432C5.46671 3.70954 6.07859 3.09766 6.83338 3.09766Z"
      fill="#C2E2FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.83338 3.09766C7.58817 3.09766 8.20004 3.70953 8.20004 4.46432V6.7421H10.0223V4.46432C10.0223 3.70954 10.6341 3.09766 11.3889 3.09766C12.1437 3.09766 12.7556 3.70953 12.7556 4.46432V6.7421H14.5778V4.46432C14.5778 3.70954 15.1897 3.09766 15.9445 3.09766C16.6993 3.09766 17.3112 3.70953 17.3112 4.46432V6.7421H19.1334V4.46432C19.1334 3.70954 19.7453 3.09766 20.5 3.09766C21.2548 3.09766 21.8667 3.70953 21.8667 4.46432V6.7421H24.6C25.6064 6.7421 26.4223 7.55794 26.4223 8.56432V23.3243C26.4223 24.3307 25.6064 25.1465 24.6 25.1465H3.64449C2.6381 25.1465 1.82227 24.3307 1.82227 23.3243V8.56432C1.82227 7.55794 2.6381 6.7421 3.64449 6.7421H5.46671L5.46671 4.46432C5.46671 3.70954 6.07859 3.09766 6.83338 3.09766Z"
      fill="url(#paint0_linear_5301_94063)"
    />
    <path
      d="M14.1224 10.9336C14.5918 13.4816 16.5855 15.4753 19.1336 15.9447C16.5855 16.4141 14.5918 18.4078 14.1224 20.9558C13.653 18.4078 11.6593 16.4141 9.11133 15.9447C11.6593 15.4753 13.653 13.4816 14.1224 10.9336Z"
      fill="#FEFEFE"
    />
  </Icon>
);
